import ResourcePage from "@/components/ResourcePage";
import { formatDeDate } from "@/lib/dateFormat";

const STATUS = [
  { value: "open", label: "Offen" },
  { value: "done", label: "Erledigt" },
  { value: "cancelled", label: "Abgebrochen" },
];

export default function FollowUpsPage() {
  return (
    <ResourcePage
      resource="followups"
      title="Wiedervorlagen"
      subtitle="Alles, woran Nora dich erinnern soll – Termine, Folgegespräche, Zusagen."
      singular="Wiedervorlage"
      newButtonLabel="Wiedervorlage anlegen"
      createDialogTitle="Wiedervorlage anlegen"
      editDialogTitle="Wiedervorlage bearbeiten"
      submitButtonLabel="Wiedervorlage speichern"
      emptyDescription="Lege deine erste Wiedervorlage an."
      emptyCreateButtonLabel="Wiedervorlage anlegen"
      testidPrefix="followups"
      defaultValues={{ status: "open" }}
      fields={[
        { name: "title", label: "Titel", type: "text", required: true },
        { name: "due_date", label: "Fällig am", type: "date", required: true },
        { name: "status", label: "Status", type: "select", options: STATUS },
        {
          name: "contact_id",
          label: "Person",
          type: "select",
          optionsFromResource: "contacts",
          optionLabel: (c) => `${c.first_name} ${c.last_name}`,
        },
        {
          name: "company_id",
          label: "Firma",
          type: "select",
          optionsFromResource: "companies",
        },
        {
          name: "assigned_to",
          label: "Zugewiesen an",
          type: "select",
          optionsFromResource: "users",
        },
        { name: "description", label: "Beschreibung", type: "textarea", fullWidth: true, rows: 4 },
      ]}
      columns={[
        { key: "title", label: "Titel", render: (r) => <span className="font-medium text-gray-900">{r.title}</span> },
        {
          key: "due_date",
          label: "Fällig",
          render: (r) => {
            const d = new Date(r.due_date);
            const overdue = r.status === "open" && d < new Date();
            return (
              <span className={overdue ? "text-rose-600 font-medium" : ""}>
                {formatDeDate(r.due_date)}
              </span>
            );
          },
        },
        { key: "status", label: "Status", badge: true },
      ]}
    />
  );
}
